module.exports = __webpack_public_path__ + "img/multiply14-4.5506919d.svg";